import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../../components/ui';

// The hand-rolled Try-It catalog has been retired. Scalar's built-in
// "Send Request" panel on the API Reference page does the same job and
// always reflects the current OpenAPI spec.
const TryIt = () => {
  return (
    <div className="p-2 md:p-4 max-w-4xl">
      <h1 className="text-3xl font-bold mb-2">Try It (Sandbox)</h1>
      <p className="text-muted-foreground mb-6">
        Fire real requests against your account directly from the API
        Reference. Scalar's interactive panel covers every endpoint.
      </p>

      <Card className="p-6 my-4">
        <h2 className="font-semibold mb-2">Where it moved</h2>
        <p className="text-sm text-gray-700 mb-4">
          The previous endpoint picker has been merged into the new{' '}
          <strong>API Reference</strong> page. Each endpoint there has a{' '}
          <em>Test Request</em> tab where you can fill in parameters, attach
          your <code className="font-mono">x-api-key</code> and workspace ID,
          and see the live response inline.
        </p>
        <Link
          to="/integration-and-api/swagger"
          className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg bg-brand-600 text-white hover:bg-brand-700 transition-colors"
        >
          Open API Reference →
        </Link>
      </Card>

      <Card className="p-4 my-4">
        <h2 className="font-semibold mb-2">Tip</h2>
        <p className="text-sm text-gray-700">
          The reference page also generates workspace-scoped request snippets in curl, Node,
          Python, PHP, Go and more — pick a language with the tab above each
          example.
        </p>
      </Card>
    </div>
  );
};

export default TryIt;
